// src/modules/app-views/ticket-events/pages/Init/components/tableColumns/statusColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';

const STATUS_COLORS = {
  draft: 'default',
  active: 'success',
  paused: 'warning',
  ended: 'error',
  'sold-out': 'purple',
};

function statusColumn(buildColumnProps) {
  return {
    key: 'status',
    title: translateX('status'),
    dataIndex: 'status',
    width: 110,
    ...buildColumnProps('status', { sort: true }),
    render: val => (
      <Tag color={STATUS_COLORS[val] || 'default'}>{translateX(val || 'draft')}</Tag>
    ),
  };
}

export default statusColumn;
